// extracted by mini-css-extract-plugin
export default {"previewed":"VariationVersionsList_previewed__ayjkP","row":"VariationVersionsList_row__ePs3e","active":"VariationVersionsList_active__0XAxF"};